import axiosInstance from "@/lib/axiosInstance";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import type { AxiosError, AxiosResponse } from "axios";

const isQueryParamOrPath = (isQueryParam?: boolean) => {
  if (isQueryParam) {
    return "?";
  }
  return "/";
};

export const getRequestFn = async (path: string, param?: string, isQueryParam?: boolean) => {
  if (param) {
    const url = `${path}${isQueryParamOrPath(isQueryParam)}${param}`;
    const res: AxiosResponse = await axiosInstance.get(url);
    return res?.data?.data;
  } else {
    const res: AxiosResponse = await axiosInstance.get(path);
    return res?.data?.data;
  }
};

interface UseGetRequestByParamProps {
  path: string;
  key: string | any[];
  param?: string;
  errorTag?: number | string;
  enabled?: boolean;
  isQueryParam?: boolean;
  refetchInterval?: number | false;
  placeholderData?: typeof keepPreviousData | false;
}

export const useGetRequestByParam = <TData = any>({
  path,
  key,
  param,
  errorTag,
  enabled = true,
  isQueryParam = false,
  refetchInterval = false,
  placeholderData,
}: UseGetRequestByParamProps) => {
  const { data, isLoading, error, refetch, isFetching, isSuccess } = useQuery<TData, AxiosError>({
    queryKey: [key, path, param, errorTag],
    queryFn: () => getRequestFn(path, param, isQueryParam),
    enabled: enabled,
    retry: 1,
    refetchInterval: refetchInterval,
    ...(placeholderData && { placeholderData }),
  });

  return { data, isLoading, error, refetch, isFetching, isSuccess };
};
